import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import PropertyLeaseTab from './pages/property-tabs/PropertyLeaseTab';
import PropertyComplianceTab from './pages/property-tabs/PropertyComplianceTab';
import PropertyMaintenanceTab from './pages/property-tabs/PropertyMaintenanceTab';
import PropertyMessagingTab from './pages/property-tabs/PropertyMessagingTab';
import PropertyNotesTab from './pages/property-tabs/PropertyNotesTab';
import Layout from './shared/layout/Layout';
import Login from "./pages/base/Login";
import Error from "./pages/base/Error";
import {useAuth} from "./shared/contexts/auth-context";
import {USER_ROLES} from "./shared/utils/permissions";
import Dashboard from './pages/Dashboard';
import Tenants from "./pages/Tenants";
import Properties from './pages/Properties';
// import PropertyDetail from './components/PropertyDetail';
import AddProperty from './pages/AddProperty';
import EditProperty from './pages/EditProperty';
import PropertyDetails from './pages/PropertyDetails';
import PropertyDocuments from './pages/PropertyDocuments';
import PropertySearchPage from './pages/PropertySearchPage'; // New import
import Landlords from './pages/Landlords';
import AddLandlord from './pages/AddLandlord';
import EditLandlord from './pages/EditLandlord';
import AddTenant from './pages/AddTenant';
import EditTenant from './pages/EditTenant';
import TenantDetails from './pages/TenantDetails';
import TenantDocuments from './pages/TenantDocuments';
import Agents from './pages/Agents';
import AddAgent from './pages/AddAgent';
import EditAgent from './pages/EditAgent';
import AgentDetails from './pages/AgentDetails';
import AgentDocuments from './pages/AgentDocuments';
import ForgotPassword from "./pages/base/ForgotPassword";
import VerifyAccount from "./pages/base/VerifyAccount";
import LandlordDetails from './pages/LandlordDetails';
import LandlordDocuments from './pages/LandlordDocuments';
import Fica from './pages/Fica';
import UserManagement from './pages/UserManagement';
import SalesDeals from './pages/sales/SalesDeals';
import AddSalesDeal from './pages/sales/AddSalesDeal';
import EditSalesDeal from './pages/sales/EditSalesDeal';
import SalesDealsDetails from './pages/sales/SalesDealsDetails';
import ProfessionalServices from './pages/sales/ProfessionalServices';
import AddProfessionalService from './pages/sales/AddProfessionalService';
import EditProfessionalService from './pages/sales/EditProfessionalService';
import ProfessionalServiceDetails from './pages/sales/ProfessionalServiceDetails';
import SalesPipelineDashboard from './pages/sales/SalesPipelineDashboard';
import CommissionStatements from './pages/sales/CommissionStatements';


function App() {

    const auth = useAuth();

    return (
        <Layout>
            {auth.user?.token ? (
                <Routes>
                    <Route path="/properties/add" element={<AddProperty/>}/>
                    <Route path="/properties/edit/:id" element={<EditProperty/>}/>
                    <Route path="/properties/:id/documents" element={<PropertyDocuments />} />
                    <Route path="/properties/:id" element={<PropertyDetails />}>
                        <Route index element={<Navigate to="lease" replace />} />
                        <Route path="lease" element={<PropertyLeaseTab />} />
                        <Route path="compliance" element={<PropertyComplianceTab />} />
                        <Route path="maintenance" element={<PropertyMaintenanceTab />} />
                        <Route path="messaging" element={<PropertyMessagingTab />} />
                        <Route path="notes" element={<PropertyNotesTab />} />
                    </Route>
                    <Route path="/properties" element={<Properties/>}/>
                    <Route path="/property-search" element={<PropertySearchPage/>}/> {/* New route */}

                    <Route path="/landlords/add" element={<AddLandlord/>}/>
                    <Route path="/landlords/edit/:id" element={<EditLandlord/>}/>
                    <Route path="/landlords/:id/documents" element={<LandlordDocuments />} />
                    <Route path="/landlords/:id" element={<LandlordDetails />} />
                    <Route path="/landlords" element={<Landlords/>}/>

                    <Route path="/tenants/add" element={<AddTenant/>}/>
                    <Route path="/tenants/edit/:id" element={<EditTenant/>}/>
                    <Route path="/tenants/:id/documents" element={<TenantDocuments />} />
                    <Route path="/tenants/:id" element={<TenantDetails />} />
                    <Route path="/tenants" element={<Tenants/>}/>

                    <Route path="/agents/add" element={<AddAgent/>}/>
                    <Route path="/agents/edit/:id" element={<EditAgent/>}/>
                    <Route path="/agents/:id/documents" element={<AgentDocuments />} />
                    <Route path="/agents/:id" element={<AgentDetails />} />
                    <Route path="/agents" element={<Agents/>}/>
                    
                    <Route path="/fica" element={<Fica/>}/>
                    
                    <Route path="/user-management" element={<UserManagement/>}/>

                    {/* Sales Pipeline Routes */}
                    <Route path="/sales/deals/add" element={<AddSalesDeal/>}/>
                    <Route path="/sales/deals/:id/edit" element={<EditSalesDeal/>}/>
                    <Route path="/sales/deals/:id" element={<SalesDealsDetails/>}/>
                    <Route path="/sales/deals" element={<SalesDeals/>}/>
                    <Route path="/sales/professional-services/add" element={<AddProfessionalService/>}/>
                    <Route path="/sales/professional-services/:id/edit" element={<EditProfessionalService/>}/>
                    <Route path="/sales/professional-services/:id" element={<ProfessionalServiceDetails/>}/>
                    <Route path="/sales/professional-services" element={<ProfessionalServices/>}/>
                    <Route path="/sales/pipeline-dashboard" element={<SalesPipelineDashboard/>}/>
                    <Route path="/sales/commission-statements" element={<CommissionStatements/>}/>
                    
                    <Route path="/" element={
                        auth.user?.user?.role === USER_ROLES.SUPERUSER_SALES
                            ? <Navigate to="/sales/pipeline-dashboard" replace />
                            : <Dashboard/>
                    }/>
                    <Route path={"*"} element={<Error/>}/>
                </Routes>) : (
                <Routes>
                    <Route path="/verify-account/:token" element={<VerifyAccount/>}/>
                    <Route path="/forgot-password/:email/:token" element={<ForgotPassword/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword/>}/>
                    <Route path="*" element={<Login/>}/>
                </Routes>
            )}
        </Layout>
    );
}

export default App;